export default {
    bg: require('../assets/images/holidays.sky.png'),
    sprites: [{
        image: require('../assets/images/holidays.elephant.png'),
        x: 53,
        y: 5,
        rot: -5,
        scale: .7,
    }, {
        image: require('../assets/images/holidays.deer.png'),
        x: 5,
        y: 20,
        rot: 4,
        scale: .8,
    }, {
        image: require('../assets/images/holidays.plane.png'),
        x: 29,
        y: 40,
        rot: -20,
        scale: 1.85,
    }],
}